/* eslint-disable */
// FIXME: enable eslint
// this module contains interface-only state
// this is used to adapt the myhome behavior according to the state changes
import Vue from "vue";
import ModalAlert from "@/components/patterns/ModalAlert"; // eslint-disable-line import/no-extraneous-dependencies
import userLogout from "~/helpers/userLogout"; // eslint-disable-line import/no-extraneous-dependencies
import Registration from "../../clients/registrations"; // eslint-disable-line import/no-extraneous-dependencies
import router from "../../myhome-router";
import surveys from "../../surveys";

const state = {
  ticketFilter: "future",
  titles: {
    main: {
      future: "I miei prossimi corsi / corsi a cui sto partecipando",
      festival: "Gli eventi del Festival",
      past: "Corsi a cui ho partecipato",
      waitingList: "Corsi in lista d'attesa",
      ordersRecap: "I miei ordini",
      notAttended: "Corsi a cui NON ho partecipato",
    },
    sidebar: {
      future: "I miei prossimi corsi",
      festival: "Gli eventi del Festival",
      past: "Corsi a cui ho partecipato",
      waitingList: "Corsi in lista d'attesa",
      ordersRecap: "I miei ordini",
    },
    secondary: {
      future: "",
      past: "",
      waitingList: "Corsi che mi interessano",
    },
    empty: {
      future: "Nessun corso di prossimo svolgimento",
      festival: "Nessun evento del Festival",
      past: "Nessun corso a cui hai partecipato",
      waitingList: "Nessun corso in lista di attesa",
      notAttended: "Nessun corso a cui non ho partecipato",
    },
  },
  valuesSet: {
    satisfaction: [
      { value: 5, label: "Moltissimo" },
      { value: 4, label: "Molto" },
      { value: 3, label: "In parte" },
      { value: 2, label: "Poco" },
      { value: 1, label: "Molto poco" },
    ],
    quality: [
      { value: 5, label: "Eccellente" },
      { value: 4, label: "Buono" },
      { value: 3, label: "Soddisfacente" },
      { value: 2, label: "Insoddisfacente" },
      { value: 1, label: "Molto insoddisfacente" },
    ],
    yesNo: [
      { value: 1, label: "Sì" },
      { value: 0, label: "No" },
    ],
  },
  surveys,
  survey: {},
  surveyData: { laboratories: [], schedule: [] },
  questions: [],
  certificateAvailable: false,
  localRegistration: {},
  certificateLoaded: false,
};

const getters = {
  titles: moduleState => moduleState.titles,
  survey: moduleState => moduleState.survey,
  surveyData: moduleState => moduleState.surveyData,
  questions: moduleState => moduleState.questions,
  localRegistration: moduleState => moduleState.localRegistration,
  certificateLoaded: (moduleState, rootState) => {
    if (!moduleState.localRegistration) {
      moduleState.localRegistration = rootState.orders.registrations[rootState.orders.activeRegistrationIndex];
    }
    return moduleState.certificateLoaded
      ? moduleState.certificateLoaded
      : moduleState.localRegistration.dea_certificate_available;
  },
  ticketFilter: moduleState => moduleState.ticketFilter,
  valuesSet: moduleState => moduleState.valuesSet,
  typologies: moduleState => moduleState.typologies,
};

const actions = {
  async saveHomeSurvey({ dispatch, rootState }) {
    try {
      const saved = await dispatch("saveSurvey");
      if (saved) {
        const questions = await dispatch("saveQuestions");
        if (questions) {
          router.push({ name: "certificate", params: { registration: state.localRegistration.id } });
        }
      }
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async saveSurvey({ rootState, state }) {
    try {
      const certificate_url = await Registration.saveSurvey(
        rootState.config,
        rootState.orders.registrations[rootState.orders.activeRegistrationIndex].id,
        state.surveyData
      );
      if (certificate_url) {
        state.localRegistration.dea_certificate_url = certificate_url;
        state.localRegistration.dea_certificate_status = "available";
        state.localRegistration.dea_certificate_available = true;
        state.certificateLoaded = true;
      }
      return state.localRegistration.dea_certificate_available;
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async saveQuestions({ rootState, state }) {
    try {
      await Registration.saveQuestions(
        rootState.config,
        rootState.orders.registrations[rootState.orders.activeRegistrationIndex].id,
        state.questions
      );
      return true;
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  setSurvey({ state, rootState, commit }) {
    state.localRegistration = rootState.orders.registrations[rootState.orders.activeRegistrationIndex];
    commit("setInitialSurvey", state.surveys[state.localRegistration.linked_event.survey_type]);
    commit("resetQuestions");
    state.survey.general && (state.survey.general.values = state.valuesSet.satisfaction);
    state.survey.previous && (state.survey.previous.values = state.valuesSet.yesNo);
    state.survey.satisfy && (state.survey.satisfy.values = state.valuesSet.satisfaction);
    state.survey.speakers && (state.survey.speakers.values = state.valuesSet.satisfaction);
    state.survey.coveredTopics && (state.survey.coveredTopics.values = state.valuesSet.satisfaction);
    state.survey.organization && (state.survey.organization.values = state.valuesSet.satisfaction);
    state.survey.location && (state.survey.location.values = state.valuesSet.satisfaction);
    state.survey.topics && (state.survey.topics.values = state.valuesSet.satisfaction);
    state.survey.useful && (state.survey.useful.values = state.valuesSet.satisfaction);
    state.survey.learning && (state.survey.learning.values = state.valuesSet.satisfaction);
    state.survey.guided && (state.survey.guided.values = state.valuesSet.satisfaction);
    state.survey.suggest && (state.survey.suggest.values = state.valuesSet.yesNo);
    state.survey.labs && (state.survey.labs.values = state.valuesSet.satisfaction);
    if (state.survey.support) {
      state.survey.support.values = [...state.valuesSet.satisfaction, { value: 0, label: "Mai usata" }];
    }
    state.survey.analyze && (state.survey.analyze.values = state.valuesSet.satisfaction);

    for (const item in state.survey) {
      if (state.survey.hasOwnProperty(item) && ["schedule", "laboratories"].indexOf(item) === -1) {
        Vue.set(state.surveyData, item, state.survey[item].value);
      }
    }
    if (state.localRegistration) {
      if (state.localRegistration.linked_event.program.length) {
        for (const schedule of state.localRegistration.linked_event.program) {
          if (state.survey.schedule && schedule.speakers.length && schedule.duration > 0) {
            const speakers = schedule.speakers.reduce(
              (acc, curr, id) => (id === 0 ? `${acc}${curr.fullname}` : `${acc}, ${curr.fullname}`),
              ""
            );
            state.survey.schedule.items.push({
              label: `${schedule.title} - ${speakers}`,
              id: schedule.id,
              values: state.valuesSet.satisfaction,
              type: "radio",
            });
            state.surveyData.schedule.push({
              title: schedule.title,
              speakers,
              id: schedule.id,
              value: "",
            });
          }
        }
      }
      if (state.localRegistration.linked_event.sessions) {
        for (const session of state.localRegistration.linked_event.sessions) {
          if (session.selected_lab && !session.selected_lab.empty) {
            state.survey.laboratories.items.push({
              id: session.selected_lab.id,
              label: session.selected_lab.title,
              values: state.valuesSet.satisfaction,
              type: "radio",
            });
            state.surveyData.laboratories.push({
              title: session.selected_lab.title,
              id: session.selected_lab.id,
              value: "",
            });
            state.questions.push({
              title: session.selected_lab.title,
              id: session.selected_lab.id,
              question: { text: "", anonymous: false },
            });
          }
        }
      }
    }
    state.survey.completed = true;
  },
};

const mutations = {
  setInitialSurvey: (state, survey) => {
    state.survey = survey;
  },
  resetQuestions: state => {
    state.questions = [];
  },
  setTicketFilter: (state, newFilter, deepLinkedRegistration) => {
    state.mainTitle = state.titles[newFilter];
    state.ticketFilter = newFilter;
  },
  setSurveyField: (state, payload) => {
    const { item } = payload;
    const { value } = payload;
    Vue.set(state.survey, item, value);
  },
  setSurveyKey: (state, payload) => {
    const { item } = payload;
    const { value } = payload;
    Vue.set(state.surveyData, item, value);
  },
  setSurveyScheduleKey: (state, payload) => {
    const index = Number(payload.item);
    const program = state.localRegistration.linked_event.program.filter(prog => prog.speakers.length);
    const schedule = program[index];
    const scheduleItem = {
      value: Number(payload.value),
      id: schedule.id,
      title: schedule.title,
    };
    Vue.set(state.surveyData.schedule, index, scheduleItem);
  },
  setSurveyLabKey: (state, payload) => {
    const index = Number(payload.item);
    const laboratory = state.localRegistration.linked_event.sessions[index].selected_lab;
    const labItem = {
      value: Number(payload.value),
      id: laboratory.id,
      title: laboratory.title,
    };
    Vue.set(state.surveyData.laboratories, index, labItem);
  },
  setSurveyQuestion: (state, payload) => {
    const index = Number(payload.item);
    const laboratory = state.localRegistration.linked_event.sessions[index].selected_lab;
    const labQuestion = {
      question: payload.value,
      id: laboratory.id,
      title: laboratory.title,
    };
    Vue.set(state.questions, index, labQuestion);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
